<template>
  <section class="index-map">
    <section class="searchContainer">
      <div class="city" @click="setCity">
        <span class="name">{{cityInfo.city || '请选择'}}</span>
        <span class="triangle-down"></span>
      </div>
      <input class="search" maxlength="20" placeholder="请输入地址" v-model="searchTxt" @input="searchInput"/>
      <div class="cancel" @click="cancel">取消</div>
    </section>
    <section class="block_container" v-if="searchTxt">
      <div class="wrap_init">
        <div class="search_area_box" ref="searchList">
          <ul class="search_area_list">
            <li v-for="(item,index) in positionList" :key="index" @click="search(item)">
              <img class="ico" src="@/assets/images/selectAddress/postion.png"/>
              <div>
                <p>{{item.name}}</p>
                <p>{{item.address}}</p>
              </div>
            </li>
            <div class="nodata"  v-if="positionList.length == 0 && searchTime==0">
              <img src="@/assets/images/selectAddress/nofind.png"/>
              <div>未找到您输入的地址，换个地址试试把</div>
            </div>
          </ul>
        </div>
      </div>
    </section>
    <div class="defaultText"  v-else>
      <img src="@/assets/images/selectAddress/inputAddress.png"/>
      <div>输入地址，选择您的上线地址吧</div>
    </div>
  </section>
</template>
<script>
  import {
    searchAddress,
  } from "@/utils/api";
  import BScroll from "better-scroll";
  export default {
    name: 'selectAddress',
    data() {
      return {
        cityInfo: {},
        addressInfo:{},
        currentCity: {},
        searchTxt: "",
        positionList:[],
        bscroll:null
      }
    },
    created() {

    },
    mounted() {
      this.cityInfo = JSON.parse(localStorage.getItem("cityInfo")) || {};
      this.addressInfo = JSON.parse(localStorage.getItem("addressInfo")) || {};
      if(this.addressInfo.name){
        this.searchTxt = this.addressInfo.name;
        this.searchInput()
      }
    },
    watch: {},
    methods: {
      //监听BScroll
      listenScroll(element) {
        if (!this.bscroll) {
          this.bscroll = new BScroll(element, {
            probeType: 3,
            deceleration: 0.001,
            bounce: false,
            swipeTime: 3e3,
            click: true
          });
        } else {
          this.bscroll.refresh();
        }
      },
      //设置城市
      setCity() {
        this.$router.replace({name: "cityList"});
      },
      //输入搜索地址
      searchInput(e) {
        if (this.searchTxt == "") {
          this.positionList = [];
          this.searchList = [];
          return;
        }
        //延时搜索
        let delayTime = 500;
        if (this.searchTime) {
          clearTimeout(this.searchTime);
        }
        this.searchTime = setTimeout(async () => {
          let res = await searchAddress({
            data: {
              keywords: this.searchTxt,
              city: this.cityInfo.city
            },
            showError: false
          });
          if (res.Code == 100) {
            this.positionList = res.Data || [];
            this.searchTime = 0;
            this.$nextTick(() => {
              const listContainer = this.$refs.searchList;
              this.listenScroll(listContainer, 2);
            });
          }
        }, delayTime);
      },
      search(item){
        this.addressInfo = item;
        localStorage.setItem("addressInfo", JSON.stringify(this.addressInfo));
        this.$router.replace({path: '/addCar'});
      },
      clearSearch() {
        this.searchTxt = "";
      },
      cancel() {
        if (this.searchTxt) {
          this.clearSearch();
          this.positionList = [];
          return;
        }
        this.$router.replace({name: "addCar"});
      },
    },
  }
</script>
<style lang="scss" scoped type="text/scss">
  .index-map {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    .searchContainer {
      margin-top: 110px;
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      box-sizing: border-box;
      width: 100%;
      height: 80px;
      background-color: #fff;
      border-bottom: 1px solid #e5e5e5; /*no*/
      font-size: 26px;
      .city {
        display: flex;
        align-items: center;
        padding-right: 20px;
        border-right: 1px solid #e5e5e5; /*no*/
        .name {
          display: flex;
          margin-right: 7px;
          align-items: center;
          position: static;
        }
        .triangle-down {
          width: 0;
          height: 0;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 7px solid #231f20;
        }
      }
      .search {
        flex: 1;
        font-size: 26px;
        border: none;
        padding: 0 10px;
      }
      .cancel {
        display: flex;
        align-items: center;
        padding-left: 20px;
        border-left: 1px solid #e5e5e5; /*no*/
        color: #999999;
      }
    }
    .block_container {
      flex: 1;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
      .wrap_init {
        display: flex;
        flex: 1;
        width: 100%;
        height: 100%;
        .block_box {
          width: 145px;
          ul.block_list {
            width: 100%;
            li {
              width: 100%;
              padding: 20px 0;
              font-size: 26px;
              color: #999;
              background: #f3f3f3;
              text-align: center;
            }
            li.on {
              background: #fff;
              color: #fe6700;
            }
            li.on::before {
              position: absolute;
              left: 0;
              content: "";
              width: 6px;
              height: 36px;
              background-color: #ff6600;
            }
          }
        }
      }
      .search_area_box {
        flex: 1;
        background: #fff;
        ul.search_area_list {
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          padding-bottom: 30px;
          li {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1px solid #e5e5e5; /*no*/
            img {
              margin-left: 20px;
              width: 32px;
              height: 26px;
            }
            > div {
              margin-left: 20px;
              p:first-child {
                font-size: 26px;
                color: #555;
              }
              p:last-child {
                font-size: 24px;
                color: #c1c1c1;
                margin-top: 5px;
              }
            }
          }
          .nodata{
            margin-top: 200px;
            text-align: center;
            color: #9F9F9F;
            img{
              margin: 0 auto;
              width: 260px;
              height: 200px;
            }
          }
        }
      }
    }
    .defaultText{
      padding-top: 200px;
      box-sizing: border-box;
      height: 100%;
      background: #fff;
      text-align: center;
      color: #9F9F9F;
      img{
        margin: 0 auto;
        width: 200px;
        height: 200px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/car/selectAddress.vue